/**
 * Created by intellicar-rinas on 9/8/17.
 */
import $http from '../helpers/$http';
import {API_HOST} from '../constants/constants';
import apiHelper from '../helpers/apiHelper';

const VehicleAPIs = {

    getMyVehicles: (body) => {
        return $http.post(API_HOST + '/api/vehicle/getmyvehicles', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    getMyVDS: (body) => {
        return $http.post(API_HOST + '/api/vehicle/getmyvds', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    getModels: (body, uid) => {
        return $http.post(API_HOST + '/api/vehicle/getmodels',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    }, 

    sendERMESafeCmd: (body, uid) => {
        return $http.post(API_HOST + '/api/vehicle/sendermesafecmd',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    }, 
    getBindDate: (body, uid) => {
        return $http.post(API_HOST + '/api/device/getbinddataforvehicle',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
};

export default VehicleAPIs;